import {
    BulletinListExportExcelRequest
} from '../dto/request/BulletinListExportExcelRequest';
import {
    BulletinListExportPdfRequest
} from '../dto/request/BulletinListExportPdfRequest';
import {
    SummaryListExportExcelRequest
} from '../dto/request/SummaryListExportExcelRequest';
import TaskBulletinListExportPdf from '../dto/ws/TaskBulletinListExportPdf';
import TaskBulletinListExportExcel from '../dto/ws/TaskBulletinListExportExcel';
import TaskSummaryListExportExcel from '../dto/ws/TaskSummaryListExportExcel';
import {
    BulletinListExportExcelResponse
} from '../dto/response/BulletinListExportExcelResponse';
import {
    BulletinListExportPdfResponse
} from '../dto/response/BulletinListExportPdfResponse';
import {
    SummaryListExportExcelResponse
} from '../dto/response/SummaryListExportExcelResponse';

export interface ApiClientResponse {
    bulletinListExportPdf: (request: BulletinListExportPdfRequest) => Promise<BulletinListExportPdfResponse>;
    bulletinListExportExcel: (request: BulletinListExportExcelRequest) => Promise<BulletinListExportExcelResponse>;
    summaryListExportExcel: (request: SummaryListExportExcelRequest) => Promise<SummaryListExportExcelResponse>;
}

const ApiClient = (): ApiClientResponse => {

    // TODO: realizado de esta forma porque pierde el async de la promesa
    const bulletinListExportPdf = async(request: BulletinListExportPdfRequest): Promise<BulletinListExportPdfResponse> => {
        const task = new TaskBulletinListExportPdf(request);
        return await (task as any);
    }

    const bulletinListExportExcel = async(request: BulletinListExportExcelRequest): Promise<BulletinListExportExcelResponse> => {
        const task = new TaskBulletinListExportExcel(request);
        return await (task as any);
    }

    const summaryListExportExcel = async(request: SummaryListExportExcelRequest): Promise<SummaryListExportExcelResponse> => {
        const task = new TaskSummaryListExportExcel(request);
        return await (task as any);
    }

    return {
        bulletinListExportPdf,
        bulletinListExportExcel,
        summaryListExportExcel,
    }
}

export default ApiClient;